import { BayLevelEnum } from "open-vessel-definition";
export function getContainersByHighestBelowOrLowestAbove(smartBay) {
    var _a, _b;
    const containers = [];
    const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();
    // For each stack, get the highest container below deck or lowest above deck
    for (const stackKey of allStacksKeys) {
        const tiersInStack = allTiersKeys.filter((tier) => { var _a; return (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[tier]; });
        if (tiersInStack.length === 0)
            continue;
        // Sort tiers from bottom to top
        const sortedTiers = tiersInStack.sort();
        // Check if this is below or above deck
        if (smartBay.level === BayLevelEnum.BELOW) {
            // Get highest below (last tier)
            const highestTier = sortedTiers[sortedTiers.length - 1];
            const content = (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[highestTier];
            if (content) {
                containers.push(...content.containers);
            }
        }
        else {
            // Get lowest above (first tier)
            const lowestTier = sortedTiers[0];
            const content = (_b = gridContent[stackKey]) === null || _b === void 0 ? void 0 : _b[lowestTier];
            if (content) {
                containers.push(...content.containers);
            }
        }
    }
    return {
        containers,
        tBaysStr: smartBay.tBaysStr,
        level: smartBay.level,
    };
}
